// Mock data for Golden Corfu Transfer website
// Replace with real data later

export const contactInfo = {
  whatsapp: "+30 6983400353",
  phone: "+30 6970339676",
  email: "goldencorfu@gmail.com",
  instagram: "@goldencorfutransfer",
  qrCodeLink: "https://goldencorfutransfer.com/booking",
  address: "Corfu International Airport, 491 00 Corfu, Greece",
  mapCoordinates: { lat: 39.6019, lng: 19.9117 }
};

// Full list of Corfu locations (for the booking search dropdown)
// Pricing destinations below are kept separate so we only show prices for places we have rates for
export const allCorfuLocations = [
  "Corfu Airport",
  "Corfu Port",
  "Corfu Town",
  "Acharavi",
  "Achilleion",
  "Afionas",
  "Afra",
  "Agios Georgios Argyrades (South)",
  "Agios Georgios Pagi (North)",
  "Agios Gordios",
  "Agios Ioannis (Aqualand)",
  "Agios Ioannis Peristeron",
  "Agios Markos",
  "Agios Spiridon",
  "Agios Stefanos Avliotes",
  "Agios Stefanos Sinies",
  "Agni",
  "Alepou",
  "Almiros",
  "Ano Korakiana",
  "Apraos-Kalamaki",
  "Aqualand",
  "Arillas",
  "Astrakeri",
  "Avlaki",
  "Avliotes",
  "Barbati",
  "Benitses",
  "Boukari",
  "Cape Drastis – Peroulades",
  "Chalikounas",
  "Corfu Golf Club",
  "Danilia",
  "Daphnila",
  "Dassia",
  "Ermones",
  "Gardenos",
  "Gastouri",
  "Glyfada",
  "Gouvia and Marina Gouvia",
  "Ipsos",
  "Issos",
  "Kalami",
  "Kaminaki",
  "Kanoni",
  "Karoussades",
  "Kassiopi",
  "Kato Korakiana",
  "Kavos",
  "Kelia (Kassiopi)",
  "Kentroma",
  "Kerasia",
  "Kommeno",
  "Kontogialos",
  "Kontokali",
  "Kouloura",
  "Lakones",
  "Lefkimmi",
  "Liapades",
  "Loggas",
  "Marathias",
  "Mesongi",
  "Messonghi",
  "Moraitika",
  "Nissaki",
  "Paleokastritsa",
  "Pantokratoras",
  "Paramonas",
  "Pelekas",
  "Pentati",
  "Perama",
  "Perithia",
  "Petriti",
  "Potamos-Alykes",
  "Prassoudi",
  "Prasoudi",
  "Roda",
  "Sidari",
  "Sinarades",
  "Sinies",
  "Spartilas",
  "Viros",
];

export const pricingData = {
  north: [
    { destination: "Sidari", small: "70€", big: "90€" },
    { destination: "Peroulades", small: "70€", big: "90€" },
    { destination: "Agios Stefanos", small: "70€", big: "90€" },
    { destination: "Arillas", small: "70€", big: "90€" },
    { destination: "Ag. Georgios (Armenades)", small: "95€", big: "115€" },
    { destination: "Karoussades", small: "90€", big: "110€" },
    { destination: "Ypsos", small: "50€", big: "60€" },
    { destination: "Dassia", small: "40€", big: "55€" },
    { destination: "Aqualand", small: "40€", big: "55€" },
    { destination: "Kassiopi", small: "70€", big: "90€" },
    { destination: "Agios Stefanos Sinies", small: "70€", big: "95€" },
    { destination: "Kalami", small: "65€", big: "85€" },
    { destination: "Nissaki", small: "55€", big: "75€" },
    { destination: "Barbati", small: "50€", big: "60€" },
    { destination: "Roda", small: "70€", big: "90€" },
    { destination: "Acharavi", small: "70€", big: "90€" },
    { destination: "Kommeno", small: "50€", big: "65€" },
    { destination: "Pantokratoras", small: "90€", big: "110€" }
  ],
  central: [
    { destination: "Paleokastritsa", small: "50€", big: "70€" },
    { destination: "Liapades", small: "50€", big: "70€" },
    { destination: "Spártila", small: "70€", big: "85€" },
    { destination: "Glyfada", small: "50€", big: "70€" },
    { destination: "Gouvia", small: "36€", big: "50€" },
    { destination: "Kontokali", small: "36€", big: "50€" },
    { destination: "Kanoni", small: "36€", big: "45€" },
    { destination: "Ermones", small: "50€", big: "70€" },
    { destination: "Pelekas", small: "50€", big: "70€" }
  ],
  south: [
    { destination: "Achilleion", small: "45€", big: "60€" },
    { destination: "Benitses", small: "40€", big: "55€" },
    { destination: "Agios Ioannis", small: "40€", big: "55€" },
    { destination: "Moraitika", small: "50€", big: "70€" },
    { destination: "Mesongi", small: "50€", big: "70€" },
    { destination: "Ag. Gordios", small: "50€", big: "70€" },
    { destination: "Paramonas", small: "70€", big: "90€" },
    { destination: "Prassoudi", small: "75€", big: "95€" },
    { destination: "Lefkimi", small: "75€", big: "120€" },
    { destination: "Gardenos", small: "70€", big: "90€" },
    { destination: "Kavos", small: "75€", big: "100€" }
  ]
};

export const services = [
  {
    title: "Airport Transfers",
    description: "Professional pickup and drop-off service from/to Corfu International Airport. Meet & greet service included.",
    icon: "Plane"
  },
  {
    title: "Port Transfers",
    description: "Convenient transfers to and from Corfu port for cruise passengers and ferry travelers.",
    icon: "Ship"
  },
  {
    title: "Hotel & Villa Transfers",
    description: "Door-to-door service to any hotel, villa, or accommodation across the island.",
    icon: "Home"
  },
  {
    title: "24/7 Availability",
    description: "Round-the-clock service for early morning flights and late-night arrivals.",
    icon: "Clock"
  },
  {
    title: "Professional Drivers",
    description: "Experienced, licensed drivers with excellent knowledge of Corfu and fluent English.",
    icon: "User"
  },
  {
    title: "Luxury Vehicles",
    description: "Modern, air-conditioned vehicles maintained to the highest standards for your comfort.",
    icon: "Car"
  }
];

export const testimonials = [
  {
    name: "Sarah Johnson",
    country: "United Kingdom",
    rating: 5,
    text: "Absolutely fantastic service! Our driver was punctual, professional, and the car was immaculate. Made our Corfu holiday start perfectly.",
    date: "March 2026"
  },
  {
    name: "Michael Schmidt",
    country: "Germany",
    rating: 5,
    text: "Best transfer service we've used in Greece. The driver helped with our luggage and gave us great tips about the island. Highly recommended!",
    date: "February 2026"
  },
  {
    name: "Emma Williams",
    country: "Ireland",
    rating: 5,
    text: "Smooth, comfortable ride from the airport to our villa. Great communication and very reasonable prices. Will definitely use again!",
    date: "April 2026"
  }
];

export const faqs = [
  {
    question: "How do I book a transfer?",
    answer: "You can book via WhatsApp, phone, email, or through our contact form. We recommend booking at least 24 hours in advance for guaranteed availability."
  },
  {
    question: "Are your prices fixed?",
    answer: "Yes, all our prices are fixed and agreed in advance. No hidden fees or surprises. The price includes meet & greet service and luggage assistance."
  },
  {
    question: "What happens if my flight is delayed?",
    answer: "We monitor all flight arrivals. If your flight is delayed, your driver will adjust the pickup time accordingly at no extra charge."
  },
  {
    question: "Do you provide child seats?",
    answer: "Yes, we provide child seats free of charge. Please inform us when booking about the age of your child so we can arrange the appropriate seat."
  },
  {
    question: "What is your cancellation policy?",
    answer: "Free cancellation up to 24 hours before the scheduled pickup time. Cancellations within 24 hours are subject to a 50% charge."
  },
  {
    question: "Can I book a transfer for a large group?",
    answer: "Absolutely! We have vehicles for groups of all sizes, including minibuses for up to 8 passengers. Contact us for group bookings."
  }
];

export const whyChooseUs = [
  {
    title: "Fixed Prices",
    description: "No surprises, no hidden fees. All prices agreed in advance.",
    icon: "BadgeEuro"
  },
  {
    title: "Local Expertise",
    description: "Our drivers are Corfu locals with extensive island knowledge.",
    icon: "MapPin"
  },
  {
    title: "Premium Comfort",
    description: "Modern, air-conditioned vehicles for a comfortable journey.",
    icon: "Star"
  },
  {
    title: "Flight Monitoring",
    description: "We track your flight and adjust pickup times automatically.",
    icon: "Radio"
  }
];
